'use strict';

function GetConstrunctionYears(ev) {
    var e = document.getElementById("SelectedCarModel");
    var selectedMake = e.options[e.selectedIndex].text;
    var constructionYearsElement = document.getElementById('constructionYears');
    var ConstructionYearsContainerElement = document.getElementById('ConstructionYearsContainer');

    //constructionYearsElement.style.display = 'none';
    constructionYearsElement.length = 0;

    axios.get('/magazine/GetConstructionYears/' + selectedMake).then(function (res) {
        ConstructionYearsContainerElement.style.display = 'block';
        var selectYear = document.createElement("option");
        selectYear.text = "Velg år";
        constructionYearsElement.add(selectYear, 0);

        for (var i = 0; i < res.data.length; i++) {
            var option = document.createElement("option");
            option.text = res.data[i];
            constructionYearsElement.add(option, i + 1);
        }
    }).catch(function (err) {
        console.error(err);
    });
}

function searchCars() {
    document.getElementById('cars').style.display = 'block';
    document.getElementById('articles').style.display = 'none';
    document.getElementById('articlesbtn').classList.remove("active");
    document.getElementById('carsbtn').classList.add("active");
}

function searchArticles() {
    document.getElementById('cars').style.display = 'none';
    document.getElementById('articles').style.display = 'block';
    document.getElementById('articlesbtn').classList.add("active");
    document.getElementById('carsbtn').classList.remove("active");
}